import React, { Component } from "react";
import { DatePicker } from "/src/component/general/DatePicker";
import { BootstrapTable } from "/src/component/table/BootstrapTable";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import EntityDropdown from "./EntityDropdown";
import Loading from "./Loading";
import Pagination from "./Pagination";
import PointFilter from "./PointFilter";
import { dataTableConfig, FILTER_DEBOUNCE_MS } from "../config/config";
import { ENTITY_TABLE, ENTITY_DROPDOWN_SETTINGS } from "../config/lang";

import { call } from "../util/action";
import { translate, regionId } from "../util/util";
import { filterUrl } from "../util/util";

// import Input from './Input';
class EntityTable extends Component {
  constructor(props) {
    super(props);

    this.defaultCreatedFromDate = new Date(new Date().setDate(new Date().getDate() - 14));

    const start = new Date();
    this.toDayDate = new Date().setHours(0, 0, 0, 0);
    // current week start
    this.curWeekStart = new Date(start);
    const day = start.getDay(); //Weekday (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
    const diff = day === 0 ? -6 : 1 - day; // If Sunday (0), then shift by -6 days
    this.curWeekStart.setDate(start.getDate() + diff);
    this.curWeekStart.setHours(0, 0, 0, 1);

    this.EndDate = start.getTime();

    this.state = {
      data: [],
      count: 0,
      loading: false,
      valid: false,

      pagination: {
        state: false,
        count: 0,
        sizePerPage: this.props.sizePerPage || 25,
        pageAmount: 1,
        page: 1,
      },

      getFilterUrlKey: props.getFilterUrlKey,

      filter: {
        merchandiser: { search: "" },

        route: { user: "", day_of_the_week: "" },

        task: {
          start: null,
          end: null,
          createdDateFrom: this.defaultCreatedFromDate,
          createdDateTo: null,
          user: "",
          no_answers: "",
          task_status: "",
          task_deadline: "",
          task_negative: "",
          network: "",
          point__network: "",
          created_by: "",
          point: "",
          point__responsible_supervisor: "",
          template: "",
          point__locality__county: regionId(this.props.me) || "",
          searchText: "",
        },

        visit: {
          user: "",
          supervisor: "",
          network: "",
          point__network: "",
          point: "",
          county: regionId(this.props.me) || "",
          start: this.curWeekStart,
          end: this.EndDate,
          date_range: "",
        },
        point: { network: "", county: regionId(this.props.me) || "", locality: "" },
      },
    };
  }

  filterToParams = (entity, filter) => {
    const params = new URLSearchParams();
    const f = filter[entity];
    const dateStr = v => {
      if (!v) return null;
      const d = new Date(v);
      if (isNaN(d)) return null;
      return d.toISOString().slice(0, 10);
    };
    const set = (key, val) => {
      if (val != null && val !== "" && val !== false) params.set(key, String(val));
    };

    if (entity === "task") {
      if (dateStr(f.start)) params.set("start", dateStr(f.start));
      if (dateStr(f.end)) params.set("end", dateStr(f.end));
      if (dateStr(f.createdDateFrom)) params.set("createdFrom", dateStr(f.createdDateFrom));
      if (dateStr(f.createdDateTo)) params.set("createdTo", dateStr(f.createdDateTo));
      set("supervisor", f.point__responsible_supervisor);
      set("network", f.point__network);
      set("template", f.template);
      set("status", f.task_status);
      set("created_by", f.created_by);
      set("point", f.point);
      set("county", f.point__locality__county);
      set("search", f.searchText);
      if (f.task_deadline) params.set("deadline", "1");
      if (f.task_negative) params.set("negative", "1");
    } else if (entity === "visit") {
      if (dateStr(f.start)) params.set("start", dateStr(f.start));
      if (dateStr(f.end)) params.set("end", dateStr(f.end));
      set("user", f.user);
      set("network", f.point__network);
      set("point", f.point);
      set("county", f.county);
      set("date_range", f.date_range);
    } else if (entity === "point") {
      set("network", f.network);
      set("county", f.county);
      set("locality", f.locality);
    } else if (entity === "merchandiser") {
      set("search", f.search);
    } else if (entity === "route") {
      set("user", f.user);
    }
    return params;
  };

  paramsToFilter = (entity, search) => {
    const params = new URLSearchParams(search);
    const filter = structuredClone(this.state.filter);
    const get = key => params.get(key);
    const getNum = key => {
      const v = params.get(key);
      return v ? (isNaN(v) ? v : Number(v)) : null;
    };

    if (entity === "task") {
      if (get("start")) filter.task.start = get("start");
      if (get("end")) filter.task.end = get("end");
      if (get("createdFrom")) filter.task.createdDateFrom = get("createdFrom");
      if (get("createdTo")) filter.task.createdDateTo = get("createdTo");
      if (get("supervisor")) filter.task.point__responsible_supervisor = getNum("supervisor");
      if (get("network")) filter.task.point__network = getNum("network");
      if (get("template")) filter.task.template = getNum("template");
      if (get("status")) filter.task.task_status = getNum("status");
      if (get("created_by")) filter.task.created_by = getNum("created_by");
      if (get("point")) filter.task.point = getNum("point");
      if (get("county")) filter.task.point__locality__county = getNum("county");
      if (get("search")) filter.task.searchText = get("search");
      if (get("deadline")) filter.task.task_deadline = true;
      if (get("negative")) filter.task.task_negative = true;
    } else if (entity === "visit") {
      if (get("start")) filter.visit.start = get("start");
      if (get("end")) filter.visit.end = get("end");
      if (get("user")) filter.visit.user = getNum("user");
      if (get("network")) filter.visit.point__network = getNum("network");
      if (get("point")) filter.visit.point = getNum("point");
      if (get("county")) filter.visit.county = getNum("county");
      if (get("date_range")) filter.visit.date_range = get("date_range");
    } else if (entity === "point") {
      if (get("network")) filter.point.network = getNum("network");
      if (get("county")) filter.point.county = getNum("county");
      if (get("locality")) filter.point.locality = getNum("locality");
    } else if (entity === "merchandiser") {
      if (get("search")) filter.merchandiser.search = get("search");
    } else if (entity === "route") {
      if (get("user")) filter.route.user = getNum("user");
    }
    return filter;
  };

  syncUrl = () => {
    const params = this.filterToParams(this.props.entity, this.state.filter);
    this.props.history.replace({ search: params.toString() });
  };

  componentDidMount() {
    const { entity } = this.props;
    const search = this.props.location?.search;
    if (search) {
      const filter = this.paramsToFilter(entity, search);
      this.setState({ filter }, () => this.load());
      return;
    }

    if (this.props.entity === "visit") {
      if (this.props.history.action === "POP") {
        localStorage.getItem("visitCurrentPage") ? localStorage.removeItem("visitCurrentPage") : null;
        localStorage.getItem("visitCurrentFilter") ? localStorage.removeItem("visitCurrentFilter") : null;
        this.load();
      } else if (["REPLACE", "PUSH"].includes(this.props.history.action) && !localStorage.getItem("visitCurrentFilter")) {
        this.load();
      } else {
        const currentVisitPage = localStorage.getItem("visitCurrentPage") ? Number(localStorage.getItem("visitCurrentPage")) : 1;
        localStorage.getItem("visitCurrentFilter") ? this.updatePaging(currentVisitPage) : null;
      }
    } else {
      this.load();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //set current visit page filter for page after component reload
    if (this.props.entity !== "visit") return;
    const currentVisitPage = localStorage.getItem("visitCurrentPage") && this.props.entity === "visit" ? Number(localStorage.getItem("visitCurrentPage")) : 1;
    let filter = this.state.filter;
    const savedFilterOption = localStorage.getItem("visitCurrentFilter");
    if (savedFilterOption && savedFilterOption !== JSON.stringify(prevState.filter["visit"])) {
      let savedFilter = null;
      try {
        savedFilter = JSON.parse(savedFilterOption); // corrupt/legacy value must not crash the update
      } catch (e) {
        savedFilter = null;
      }
      if (savedFilter) {
        Object.entries(savedFilter).forEach(([key, value]) => {
          filter["visit"][key] = value;
        });
        this.setState({ filter });
      }
    }
    //set current visit page for correct navigation from visit page after component reload
    if (currentVisitPage && prevState.pagination.page !== currentVisitPage) {
      setTimeout(() => {
        this.updatePaging(currentVisitPage);
      }, 250);
    }
  }

  load = () => {
    this.setState({ loading: true });

    if (this.props.type && this.props.type === "data") {
      this.setState({ data: this.props.data, loading: false, count: this.props.data.length });
      return;
    }

    let { entity } = this.props;
    let { pagination } = this.state;
    let url = entity + "s/";

    if (entity === "merchandiser") {
      // Merchandiser list: request a page and (optionally) a server search term.
      url += "?page=" + pagination.page;
      const search = this.state.filter.merchandiser?.search;
      if (search) url += "&search=" + encodeURIComponent(search);
    } else {
      let urlFilter = filterUrl(entity, this.state.filter[entity]);
      if (entity === "task" || entity === "visit" || entity === "point") {
        url += "?page=" + pagination.page;
        // Send an explicit page_size for visits so the client pager (sizePerPage)
        // stays in sync with the server instead of relying on its default.
        if (entity === "visit") url += "&page_size=" + pagination.sizePerPage;
      }
      if (urlFilter) url += urlFilter;
    }

    call({ method: "GET", url }, response => {
      if (entity === "task" || entity === "visit" || entity === "point") {
        const count = response.count || 0;
        const results = response.results || [];
        const newPagination = {
          state: true,
          pageAmount: Math.ceil(count / pagination.sizePerPage),
          count: count,
          page: pagination.page,
          sizePerPage: pagination.sizePerPage,
        };
        this.setState({ data: results, count: count, loading: false, pagination: newPagination });

        if (this.props.dataPoints) this.props.dataPoints(results);
      } else if (entity === "merchandiser") {
        // Support both a server-paginated response ({ results, count }) and a plain array
        // (endpoint returns the full list) — in the latter case, paginate on the client.
        const isServerPaged = response && !Array.isArray(response) && Array.isArray(response.results);
        const all = isServerPaged ? response.results : Array.isArray(response) ? response : [];
        const count = isServerPaged ? response.count : all.length;
        const start = isServerPaged ? 0 : (pagination.page - 1) * pagination.sizePerPage;
        const pageItems = isServerPaged ? all : all.slice(start, start + pagination.sizePerPage);
        this.setState({
          data: pageItems,
          count,
          loading: false,
          pagination: { ...pagination, state: true, count, pageAmount: Math.ceil(count / pagination.sizePerPage) },
        });
      } else if (response.length > 0) {
        this.setState({ data: response, count: response.count, loading: false });
      } else {
        this.setState({ data: [], count: 0, loading: false });
      }
    });
  };

  setDateAgo = (option = "today") => {
    const today = new Date();
    let date;

    switch (option) {
      case "today": {
        date = new Date(this.toDayDate);
        break;
      }

      case "yesterday": {
        const todayFromStart = new Date(this.toDayDate);
        date = new Date(todayFromStart.setDate(today.getDate() - 1));
        break;
      }

      case "current_week": {
        date = this.curWeekStart;
        break;
      }

      case "last_week": {
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
        lastWeekStart.setHours(23, 59, 59, 999);
        date = lastWeekStart;
        break;
      }

      case "current_month": {
        const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        date = currentMonthStart;
        break;
      }

      case "last_month": {
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        date = lastMonthStart;
        break;
      }

      case "last_half_a_year": {
        const lastHalfYear = new Date(this.toDayDate);
        lastHalfYear.setMonth(today.getMonth() - 6);
        date = lastHalfYear;
        break;
      }

      default:
        throw new Error("Invalid option");
    }

    return date.getTime();
  };

  prepareSavedFilterOption = filter => {
    for (const key in filter) {
      if (filter[key] === null || filter[key] === undefined) {
        filter[key] = "";
      }
    }
  };

  changeFilter = (entity, filterEntity, item) => {
    let filter = this.state.filter;
    const dateAndTextFilters = ["start", "end", "createdDateFrom", "createdDateTo", "searchText"];
    const now = new Date();
    const startOfWeek = new Date(now); //copy for start of the week

    switch (true) {
      case entity === "merchandiser" && filterEntity === "search":
        filter[entity][filterEntity] = item.target.value;
        break;

      case entity === "task" && dateAndTextFilters.includes(filterEntity):
        filter[entity][filterEntity] = item;
        break;

      case entity === "task" && filterEntity === "task_deadline":
        filter[entity][filterEntity] = item.target?.checked;
        break;

      case entity === "task" && filterEntity === "task_negative":
        filter[entity][filterEntity] = item.target?.checked;
        break;

      case entity === "visit" && filterEntity === "point":
        // filter[entity][filterEntity] = item; //if need to multiple points
        if (!item) {
          filter[entity][filterEntity] = "";
        } else {
          filter[entity][filterEntity] = item.id;
        }
        break;

      case (entity === "visit" && filterEntity === "start") || (entity === "visit" && filterEntity === "end"):
        filter[entity][filterEntity] = item;
        break;

      case entity === "visit" && filterEntity === "date_range":
        if (item) {
          filter[entity][filterEntity] = item.value;
          filter[entity]["start"] = item.value;
          if (item.id === 1) {
            //yesterday
            filter[entity]["end"] = this.toDayDate;
          } else if (item.id === 3) {
            //last_week
            startOfWeek.setDate(now.getDate() - now.getDay());
            filter[entity]["end"] = startOfWeek.setHours(23, 59, 59, 999);
          } else if (item.id === 5) {
            //last_month
            filter[entity]["end"] = new Date(now.getFullYear(), now.getMonth(), 1);
          } else {
            // if (item.id != 1) filter[entity]["end"] = this.EndDate;
            filter[entity]["end"] = this.EndDate;
          }
        } else {
          filter[entity][filterEntity] = "";
        }
        break;
      default:
        filter[entity][filterEntity] = item?.id;
        break;
    }
    if (entity === "visit") {
      this.prepareSavedFilterOption(filter.visit);
      localStorage.setItem("visitCurrentFilter", JSON.stringify(filter.visit));
    }
    if (entity === "point") {
      this.state.getFilterUrlKey({ key: filterEntity, value: item?.id });
    }

    if (entity === "point" && this.props.onBeforeChange) {
      this.props.onBeforeChange(() => {
        this.setState({ filter }, () => {
          this.syncUrl();
          this.updatePaging(1, undefined, true);
        });
      });
    } else {
      this.setState({ filter }, () => {
        if (entity !== "visit") {
          this.syncUrl();
          // Free-text search fields fire on every keystroke — debounce the fetch. Selects,
          // dates and checkboxes apply immediately.
          const isTextSearch = filterEntity === "searchText" || filterEntity === "search";
          if (isTextSearch) {
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => this.updatePaging(1), FILTER_DEBOUNCE_MS);
          } else {
            this.updatePaging(1);
          }
        }
      });
    }
  };

  componentWillUnmount() {
    clearTimeout(this.searchDebounceTimer);
  }

  submit = () => {
    this.syncUrl();
    this.updatePaging(1);
  };

  clearFilter = () => {
    let filter = structuredClone(this.state.filter);

    Object.keys(filter[this.props.entity])?.map(item => {
      if (this.props.entity === "visit") {
        localStorage.getItem("visitCurrentPage") ? localStorage.removeItem("visitCurrentPage") : null;
        localStorage.getItem("visitCurrentFilter") ? localStorage.removeItem("visitCurrentFilter") : null;
        filter[this.props.entity][item] = null;
      } else {
        filter[this.props.entity][item] = null;
      }

      if (item === "createdDateFrom") {
        filter[this.props.entity][item] = this.defaultCreatedFromDate;
      }

      if (this.props.entity === "visit" && item === "start") {
        filter[this.props.entity][item] = this.curWeekStart;
      }
      if (this.props.entity === "visit" && item === "end") {
        filter[this.props.entity][item] = this.EndDate;
      }

      if (item === "task_deadline" || item === "task_negative") {
        filter[this.props.entity][item] = false;
      }
    });

    if (this.props.entity === "point") {
      this.state.getFilterUrlKey(null);
    }
    this.props.history.replace({ search: "" });
    this.setState({ filter }, () => {
      this.updatePaging(1);
    });
  };

  // PAGINATION
  updatePaging = (page, cb, skipBeforeChange = false) => {
    const applyChange = () => {
      let { pagination } = this.state;
      pagination.page = page;

      //set current visit page for correct navigation from visit page
      if (this.props.entity === "visit") localStorage.setItem("visitCurrentPage", pagination.page);

      this.setState({ pagination }, () => {
        this.load();
        if (cb) cb();

        //scroll to top after change navigation
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    };

    if (this.props.entity === "point" && this.props.onBeforeChange && !skipBeforeChange) {
      this.props.onBeforeChange(applyChange);
    } else {
      applyChange();
    }
  };

  render() {
    if (!this.props.me) return null;

    const { data, loading, filter } = this.state;
    const { entity, me, openVisitFn, rowClassName } = this.props;
    let isNewBtn = ["merchandiser", "task"].indexOf(this.props.entity) != -1;

    return (
      <div className="container-fluid">
        {isNewBtn && (
          <div className="row mb-2">
            <div className="col-12 text-right">
              {this.props.entity !== "task" && (
                <Link to={"/" + this.props.entity + "/new"} className="md-create-btn">
                  <span className="material-symbols-outlined">add</span> {translate(ENTITY_TABLE, "create_btn", me.language)}
                </Link>
              )}
              {this.props.entity === "task" && (
                <Link to={"/task/new/point"} className="md-create-btn">
                  <span className="material-symbols-outlined">add</span> {translate(ENTITY_TABLE, "to_point_btn", me.language)}
                </Link>
              )}
            </div>
          </div>
        )}
        <div className="md-filter-panel">
          {entity === "merchandiser" && (
            <div className="md-search-wrap">
              <input
                type="text"
                className="md-search-input"
                placeholder={translate(ENTITY_TABLE, "search_placeholder", me.language)}
                value={filter.merchandiser.search}
                onChange={e => this.changeFilter("merchandiser", "search", e)}
              />
            </div>
          )}

          {entity === "route" && (
            <div className="md-filter-grid">
              <div className="md-filter-field">
                <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "merchandiser", me.language)}</span>
                <EntityDropdown entity="merchandiser" value={filter.route.user} onChange={o => this.changeFilter("route", "user", o)} />
              </div>
            </div>
          )}

          {entity === "task" && (
            <React.Fragment>
              <div className="md-filter-grid">
                <div className="md-filter-field md-filter-field--dates">
                  <span className="md-filter-label">{translate(ENTITY_TABLE, "start_date", me.language)}</span>
                  <DatePicker
                    selected={filter.task.start}
                    className="datePicker"
                    onChange={date => this.changeFilter("task", "start", date)}
                    placeholderText={translate(ENTITY_TABLE, "start_date", me.language)}
                    isClearable={true}
                  />
                </div>
                <div className="md-filter-field md-filter-field--dates">
                  <span className="md-filter-label">{translate(ENTITY_TABLE, "creation_date_from", me.language)}</span>
                  <DatePicker
                    selected={filter.task.createdDateFrom}
                    className="datePicker"
                    onChange={date => this.changeFilter("task", "createdDateFrom", date)}
                    placeholderText={translate(ENTITY_TABLE, "creation_date_from", me.language)}
                    isClearable={true}
                  />
                </div>
                <div className="md-filter-field md-filter-field--dates">
                  <span className="md-filter-label">{translate(ENTITY_TABLE, "creation_date_to", me.language)}</span>
                  <DatePicker
                    selected={filter.task.createdDateTo}
                    className="datePicker"
                    onChange={date => this.changeFilter("task", "createdDateTo", date)}
                    placeholderText={translate(ENTITY_TABLE, "creation_date_to", me.language)}
                    isClearable={true}
                  />
                </div>
                {me.role === "supervisor_manager" && (
                  <div className="md-filter-field">
                    <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "supervisor", me.language)}</span>
                    <EntityDropdown
                      entity="supervisor"
                      value={filter.task.point__responsible_supervisor}
                      onChange={o => this.changeFilter("task", "point__responsible_supervisor", o)}
                    />
                  </div>
                )}
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "network", me.language)}</span>
                  <EntityDropdown entity="point__network" value={filter.task.point__network} onChange={o => this.changeFilter("task", "point__network", o)} />
                </div>
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "template", me.language)}</span>
                  <EntityDropdown entity="template" value={filter.task.template} onChange={o => this.changeFilter("task", "template", o)} />
                </div>
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "task_status", me.language)}</span>
                  <EntityDropdown entity="task_status" value={filter.task.task_status} onChange={o => this.changeFilter("task", "task_status", o)} />
                </div>
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "created_by", me.language)}</span>
                  <EntityDropdown entity="created_by" value={filter.task.created_by} onChange={o => this.changeFilter("task", "created_by", o)} />
                </div>
              </div>
              <div className="md-filter-grid md-filter-grid--point">
                <PointFilter
                  value={filter.task.point}
                  moduleFilter={filter.task?.point__network}
                  onChange={option => this.changeFilter("task", "point", option)}
                  onChangeRegion={option => this.changeFilter("task", "point__locality__county", option)}
                />
              </div>
              <div className="md-filter-actions">
                <div className="md-filter-actions-left">
                  <div className="task-form-group">
                    <label>
                      <input
                        type="checkbox"
                        name="task_deadline"
                        className="form-filter-checkbox"
                        checked={filter.task.task_deadline}
                        value={filter.task.task_deadline}
                        onChange={e => this.changeFilter("task", "task_deadline", e)}
                      />
                      {translate(ENTITY_TABLE, "filter_overdue_tasks", me.language)}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="task_negative"
                        className="form-filter-checkbox"
                        checked={filter.task.task_negative}
                        value={filter.task.task_negative}
                        onChange={e => this.changeFilter("task", "task_negative", e)}
                      />
                      {translate(ENTITY_TABLE, "filter_tasks_with_negative_responses", me.language)}
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "200px" }}
                    placeholder={translate(ENTITY_TABLE, "search_placeholder", me.language)}
                    value={filter.task.searchText}
                    onChange={e => this.changeFilter("task", "searchText", e.target.value)}
                  />
                </div>
                <div className="md-filter-actions-right">
                  <button className="btn btn-outline-primary" onClick={this.clearFilter}>
                    {translate(ENTITY_TABLE, "filter_reset_btn", me.language)}
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}

          {entity === "visit" && (
            <React.Fragment>
              <div className="md-filter-grid">
                <div className="md-filter-field md-filter-field--dates">
                  <span className="md-filter-label">Дата</span>
                  <div className="md-filter-dates">
                    <DatePicker
                      selected={filter.visit.start ? new Date(filter.visit.start) : null}
                      className="datePicker"
                      onChange={date => this.changeFilter("visit", "start", date)}
                    />
                    <span className="md-filter-date-sep">—</span>
                    <DatePicker
                      selected={filter.visit.end ? new Date(filter.visit.end) : null}
                      className="datePicker"
                      onChange={date => this.changeFilter("visit", "end", date)}
                    />
                  </div>
                </div>
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "date_range", me.language)}</span>
                  <EntityDropdown
                    setDateAgo={this.setDateAgo}
                    entity="date_range"
                    placeholder={translate(ENTITY_DROPDOWN_SETTINGS, "date_current_week", me.language)}
                    value={filter.visit.date_range}
                    onChange={o => this.changeFilter("visit", "date_range", o)}
                  />
                </div>
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "merchandiser", me.language)}</span>
                  <EntityDropdown entity="merchandiser" value={filter.visit.user} onChange={o => this.changeFilter("visit", "user", o)} />
                </div>
                <div className="md-filter-field">
                  <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "network", me.language)}</span>
                  <EntityDropdown entity="network" value={filter.visit.point__network} onChange={o => this.changeFilter("visit", "point__network", o)} />
                </div>
              </div>
              <div className="md-filter-grid md-filter-grid--point">
                <PointFilter
                  saveValue={filter.visit.county}
                  value={filter.visit.point}
                  onChange={o => this.changeFilter("visit", "point", o)}
                  onChangeRegion={o => this.changeFilter("visit", "county", o)}
                  isMulti={false}
                  moduleFilter={filter.visit.point__network}
                />
              </div>
              <div className="md-filter-actions">
                <div className="md-filter-actions-left">
                  <button className="btn btn-primary" onClick={this.submit}>
                    {translate(ENTITY_TABLE, "apply_btn", me.language)}
                  </button>
                  <button className="btn btn-outline-primary" onClick={this.clearFilter}>
                    {translate(ENTITY_DROPDOWN_SETTINGS, "filter_reset", me.language)}
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}

          {entity === "point" && (
            <div className="md-filter-grid">
              <div className="md-filter-field">
                <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "network", me.language)}</span>
                <EntityDropdown entity="network" value={filter.point.network} onChange={o => this.changeFilter("point", "network", o)} />
              </div>
              <div className="md-filter-field">
                <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "region", me.language)}</span>
                <EntityDropdown entity="county" value={filter.point.county} onChange={o => this.changeFilter("point", "county", o)} />
              </div>
              <div className="md-filter-field">
                <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "city", me.language)}</span>
                <EntityDropdown entity="locality" value={filter.point.locality} onChange={o => this.changeFilter("point", "locality", o)} />
              </div>
              {(filter.point.network || filter.point.county || filter.point.locality) && (
                <div className="md-filter-field" style={{ flex: "0 0 auto", justifyContent: "flex-end" }}>
                  <button className="btn btn-outline-secondary btn-sm" onClick={() => this.clearFilter()}>
                    <i className="fa fa-times" /> {translate(ENTITY_TABLE, "filter_reset_btn", me.language)}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="filtered-task-data">
          <Loading loading={loading} />

          {/*<BootstrapTableNext keyField="id" data={data} columns={columns} pagination={paginationFactory(dataTableConfig)} />*/}
          {/*<BootstrapTableNext*/}
          {/*  data={data}*/}
          {/*  version="4"*/}
          {/*  striped*/}
          {/*  hover*/}
          {/*  pagination={false}*/}
          {/*  search={false}*/}
          {/*  multiColumnSearch={true}*/}
          {/*  options={{ ...dataTableConfig }}*/}
          {/*  className="themed-main-table-container"*/}
          {/*  tableHeaderClass="primary">*/}
          {/*  {this.props.children}*/}
          {/*</BootstrapTableNext>*/}

          <BootstrapTable
            data={data}
            version="4"
            striped
            hover
            bordered={false}
            pagination={false}
            search={false}
            multiColumnSearch={true}
            options={{ ...dataTableConfig, onRowClick: openVisitFn }}
            className="themed-main-table-container"
            trClassName={rowClassName ? rowClassName : ""}
            tableHeaderClass="primary">
            {this.props.children}
          </BootstrapTable>

          <Pagination
            pagination={this.state.pagination}
            updatePage={page => {
              this.updatePaging(page);
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(connect(state => ({ me: state.me }))(EntityTable));
